import React from 'react'
import { Row, Col } from 'antd'
import { h2Bottom } from "../../assets"

function Section1({ data, pt }) {
    return (
        <div className="section section1"
            style={{
                background: data?.bg ? `url(${data?.bg})` : data?.bgColor,
                paddingTop: pt && pt
            }}>
            <Row justify="space-evenly" align='top'  >

                <Col style={{ width: 'min(600px,100%)' }}>
                    <h3 dangerouslySetInnerHTML={{ __html: data?.h3 }} />
                    <h1 dangerouslySetInnerHTML={{ __html: data?.h1 }} />
                    {data?.h2 && <h2 dangerouslySetInnerHTML={{ __html: data?.h2 }} />}
                    {data?.h2 && <img src={h2Bottom} alt="svg" />}
                    <p dangerouslySetInnerHTML={{ __html: data?.p }} />
                    <p className='pSmall' dangerouslySetInnerHTML={{ __html: data?.pSmall }} />
                </Col>
                <Col>
                    <img
                        src={data?.img}
                        alt="img"
                        loading="lazy"
                        srcSet={data?.srcset}
                        sizes={data?.sizes}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default Section1